export default "__VITE_ASSET__pXgrDq8r__"